import React, { useMemo } from 'react';
import { Text, StyleSheet } from 'react-native';
import { usePaymentDesignTokens, PAYMENT_TYPOGRAPHY } from '@/constants/residents/mobile/paymentDesignTokens';
import { mobilePaymentsStrings } from '@/constants/residents/strings';
import { PaymentBottomSheet } from './PaymentBottomSheet';

interface PendingPaymentsModalProps {
  visible: boolean;
  onClose: () => void;
}

/**
 * Pending Payments Modal
 * Bottom sheet that explains pending payment status
 * Matches Figma design: "Payments pending pop up"
 */
export const PendingPaymentsModal: React.FC<PendingPaymentsModalProps> = ({
  visible,
  onClose,
}) => {
  const pt = usePaymentDesignTokens();

  const styles = useMemo(() => StyleSheet.create({
    descriptionText: {
      ...PAYMENT_TYPOGRAPHY.bodySm,
      color: pt.TEXT_PRIMARY,
      lineHeight: 21,
    },
}), [pt]);

  return (
    <PaymentBottomSheet
      visible={visible}
      onClose={onClose}
      title={mobilePaymentsStrings.paymentsPending}
    >
      <Text style={styles.descriptionText}>
        {mobilePaymentsStrings.paymentsPendingMessage}
      </Text>
    </PaymentBottomSheet>
  );
};

